import { merchantConstants } from "../constants/merchantConstants";
import { merchantService } from "../../services/API/merchantService";
import { alertActions } from "./alert.actions";
import { history } from "../store/configureStore";
import Alert from "../../components/alert/Alert";

export const merchantActions = {
  add_merchant,
  get_merchant_type,
  add_merchant_location,
  get_merchant,
  get_merchant_location,
  update_merchant,
  delete_merchant_location,
  getMerchantType,
  get_merchant_location_details,
  get_default_tax,
  unArchive,
};
function add_merchant(postData) {
  return dispatch => {
    dispatch(request());
    merchantService.add_merchant(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: merchantConstants.ADD_MERCHANT_REQUEST, data };
  }
  function success(data) {
    return { type: merchantConstants.ADD_MERCHANT_SUCCESS, data };
  }
  function failure(error) {
    return { type: merchantConstants.ADD_MERCHANT_FAILURE, error };
  }
}

function add_merchant_location(postData, merchantID) {
  return dispatch => {
    dispatch(request());
    merchantService.add_merchant_location(postData, merchantID).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: merchantConstants.ADD_MERCHANT_LOCATION_REQUEST, data };
  }
  function success(data) {
    return { type: merchantConstants.ADD_MERCHANT_LOCATION_SUCCESS, data };
  }
  function failure(error) {
    return { type: merchantConstants.ADD_MERCHANT_LOCATION_FAILURE, error };
  }
}

function get_merchant_type() {
  return dispatch => {
    merchantService.get_merchant_type().then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: merchantConstants.GET_MERCHANT_TYPE_LIST_REQUEST, data };
  }
  function success(data) {
    return { type: merchantConstants.GET_MERCHANT_TYPE_LIST_SUCCESS, data };
  }
  function failure(error) {
    return { type: merchantConstants.GET_MERCHANT_TYPE_LIST_FAILURE, error };
  }
}

export const getMerchantType = (postData) => {
  return dispatch => {
    merchantService.get_merchant_type(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: merchantConstants.GET_MERCHANT_TYPE_LIST_REQUEST, data };
  }
  function success(data) {
    return { type: merchantConstants.GET_MERCHANT_TYPE_LIST_SUCCESS, data };
  }
  function failure(error) {
    return { type: merchantConstants.GET_MERCHANT_TYPE_LIST_FAILURE, error };
  }
};

export const get_merchant_list = formData => {
  return dispatch => {
    merchantService.get_merchant_list(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: merchantConstants.GET_MERCHANT_LIST_REQUEST, data };
  }
  function success(data) {
    return { type: merchantConstants.GET_MERCHANT_LIST_SUCCESS, data };
  }
  function failure(error) {
    return { type: merchantConstants.GET_MERCHANT_LIST_FAILURE, error };
  }
};

export const delete_merchant = merchantIDParams => {
  return dispatch => {
    merchantService.delete_merchant(merchantIDParams).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: merchantConstants.DELETE_MERCHANT_REQUEST, data };
  }
  function success(data) {
    return { type: merchantConstants.DELETE_MERCHANT_SUCCESS, data };
  }
  function failure(error) {
    return { type: merchantConstants.DELETE_MERCHANT_FAILURE, error };
  }
};

function delete_merchant_location(merchantID, locID) {
  return dispatch => {
    dispatch(request());
    merchantService.delete_merchant_location(merchantID, locID).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: merchantConstants.DELETE_MERCHANT_LOCATION_REQUEST, data };
  }
  function success(data) {
    return { type: merchantConstants.DELETE_MERCHANT_LOCATION_SUCCESS, data };
  }
  function failure(error) {
    return { type: merchantConstants.DELETE_MERCHANT_LOCATION_FAILURE, error };
  }
}

export const get_merchant_details = merchantIdParams => {
  return dispatch => {
    merchantService.get_merchant_details(merchantIdParams).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: merchantConstants.GET_MERCHANT_DETAILS_REQUEST, data };
  }
  function success(data) {
    return { type: merchantConstants.GET_MERCHANT_DETAILS_SUCCESS, data };
  }
  function failure(error) {
    return { type: merchantConstants.GET_MERCHANT_DETAILS_FAILURE, error };
  }
};

export const get_merchant_details_id = (merchantIdParams, siteID) => {
  return dispatch => {
    dispatch(request());
    merchantService.get_merchant_details_id(merchantIdParams, siteID).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: merchantConstants.GET_MERCHANT_DETAILS_REQUEST, data };
  }
  function success(data) {
    return { type: merchantConstants.GET_MERCHANT_DETAILS_SUCCESS, data };
  }
  function failure(error) {
    return { type: merchantConstants.GET_MERCHANT_DETAILS_FAILURE, error };
  }
};

export const get_merchant_location_details = (merchantIdParams, siteID) => {
  return dispatch => {
    merchantService.get_merchant_location_details(merchantIdParams, siteID).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return {
      type: merchantConstants.GET_MERCHANT_LOCATION_DETAILS_REQUEST,
      data
    };
  }
  function success(data) {
    return {
      type: merchantConstants.GET_MERCHANT_LOCATION_DETAILS_SUCCESS,
      data
    };
  }
  function failure(error) {
    return {
      type: merchantConstants.GET_MERCHANT_LOCATION_DETAILS_FAILURE,
      error
    };
  }
};

function get_merchant(merchantIdParams) {
  return dispatch => {
    merchantService.get_merchant_details(merchantIdParams).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: merchantConstants.GET_MERCHANT_DETAILS_REQUEST, data };
  }
  function success(data) {
    return { type: merchantConstants.GET_MERCHANT_DETAILS_SUCCESS, data };
  }
  function failure(error) {
    return { type: merchantConstants.GET_MERCHANT_DETAILS_FAILURE, error };
  }
}

function get_merchant_location(merchantIdParams) {
  return dispatch => {
    merchantService.get_merchant_location_details(merchantIdParams).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return {
      type: merchantConstants.GET_MERCHANT_LOCATION_DETAILS_REQUEST,
      data
    };
  }
  function success(data) {
    return {
      type: merchantConstants.GET_MERCHANT_LOCATION_DETAILS_SUCCESS,
      data
    };
  }
  function failure(error) {
    return {
      type: merchantConstants.GET_MERCHANT_LOCATION_DETAILS_FAILURE,
      error
    };
  }
}

function update_merchant(postData) {
  return dispatch => {
    dispatch(request());
    merchantService.update_merchant(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: merchantConstants.UPDATE_MERCHANT_REQUEST, data };
  }
  function success(data) {
    return { type: merchantConstants.UPDATE_MERCHANT_SUCCESS, data };
  }
  function failure(error) {
    return { type: merchantConstants.UPDATE_MERCHANT_FAILURE, error };
  }
}

function get_default_tax(postData) {
  return dispatch => {
    merchantService.get_default_tax(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: merchantConstants.GET_DEFAULT_TAX_REQUEST, data };
  }
  function success(data) {
    return { type: merchantConstants.GET_DEFAULT_TAX_SUCCESS, data };
  }
  function failure(error) {
    return { type: merchantConstants.GET_DEFAULT_TAX_FAILURE, error };
  }
}

export const unArchive = postData => {
  return dispatch => {
    merchantService.update_merchant(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: merchantConstants.UPDATE_MERCHANT_REQUEST, data };
  }
  function success(data) {
    return { type: merchantConstants.UPDATE_MERCHANT_SUCCESS, data };
  }
  function failure(error) {
    return { type: merchantConstants.UPDATE_MERCHANT_FAILURE, error };
  }
};




// WEBPACK FOOTER //
// ./src/app/redux/actions/merchantActions.js